import { StoryPackSchema, type StoryPack } from '../types.js';

export function parseStoryPack(json: unknown): StoryPack {
  return StoryPackSchema.parse(json);
}
